import { PaymentMethod } from '@stripe/stripe-js';
import AllSubscriptions from 'src/models/AllSubscriptions';

export enum ReactivationScenario {
  HAS_SUBSCRIPTION_HAS_PAYMENT = 'HAS_SUBSCRIPTION_HAS_PAYMENT',
  HAS_SUBSCRIPTION_NO_PAYMENT = 'HAS_SUBSCRIPTION_NO_PAYMENT',
  NO_SUBSCRIPTION_NO_PAYMENT = 'NO_SUBSCRIPTION_NO_PAYMENT',
}

export enum ReactivationCampaignType {
  FREE_MONTH = 'FREE_MONTH_REACTIVATION',
  DISCOUNT_ROLLOVER = 'DISCOUNT_ROLLOVER_REACTIVATION',
}

export type ReactivationSubscriptionDetails =
  AllSubscriptions['currentSubscription'] & {
    planId?: string;
    priceId?: string;
    originalTotalPrice?: string | number;
  };

export interface ReactivationDetails {
  scenario: ReactivationScenario;
  subscription: ReactivationSubscriptionDetails | null;
  paymentMethod: PaymentMethod | null;
  shouldOnlyReactivateSubscription?: boolean;
  campaignType?: ReactivationCampaignType | null;
}

export interface CancelReactivatePayload {
  userId: number;
  email: string;
  campaignCode?: string | null;
}
